package com.rabbitsign.common

enum class DocumentType {
    FOLDER, TEMPLATE, BATCH, USER_LOGO
}
